export class ListOfEmployeeHolidayAccountResponse {
	id: number;
	account_name: string;
	account_type: string;
	account_value: string;
	internal_id: number;
	calculation_date: string;
}
